import {ApiResponseCodes as BizkeytechApiResponseCodes} from "../../../@bizkeytech";

/**
 * @inheritDoc
 */
class ApiResponseCodes extends BizkeytechApiResponseCodes {


    /**
     * @inheritDoc
     */
    static getMessageFromCode(code?: number) {
        switch (code) {
            default:
                return super.getMessageFromCode(code);
        }
    }
}

export default ApiResponseCodes;
